const ITEMS = [
  "AXE DARK TEMPTATION",
  "AXE APOLLO",
  "AXE AFRICA",
  "AXE BLACK",
  "AXE EPIC FRESH",
  "AXE MARINE",
  "AXE SUNSET FRESH",
  "AXE CLICK",
  "AXE LEATHER & COOKIES",
  "AXE COPPER SANTAL",
  "AXE BLACK VANILLA",
  "AXE WILD MOJITO",
];

export const Marquee = () => (
  <div className="relative border-y border-gold/15 bg-ink/60 py-6 overflow-hidden">
    <div className="marquee-track items-center gap-0">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center shrink-0">
              <span className="font-serif text-xl sm:text-2xl tracking-[0.14em] text-cream/85 px-8 whitespace-nowrap">
                {item}
              </span>
              <span className="text-gold text-xs">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
